var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureSqlWarehouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a39",
    x1: 7.37,
    y1: 0.5,
    x2: 7.37,
    y2: 13.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b2b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#afaeaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b39",
    x1: 8.96,
    y1: 13.29,
    x2: 17.32,
    y2: 13.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#0060a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0071c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0074cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#006abb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005ba1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M7.37.5L.68 4.38v.96h1.23v7.28h1.21V5.34h8.5v7.89h1.21V5.34h1.23v-.96L7.37.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33 12.62h2.43V10.2H4.33zm3.64 0h2.43V10.2H8zM4.33 9h2.43V6.55H4.33zM8 6.55V9h2.4V6.55z",
    fill: "#50e6ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.14 10.41c-2.31 0-4.14-.6-4.14-1.33v7.09c0 .73 1.84 1.32 4.12 1.33h.06c2.31 0 4.18-.6 4.18-1.33V9.08c-.04.73-1.91 1.33-4.22 1.33z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.32 9.08c0 .73-1.87 1.33-4.18 1.33S9 9.81 9 9.08s1.87-1.33 4.18-1.33 4.18.59 4.18 1.33",
    fill: "#e8e8e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.35 9c0 .47-1.44.85-3.21.85s-3.2-.41-3.2-.85 1.43-.85 3.2-.85 3.21.38 3.21.85",
    fill: "#50e6ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.14 9.17a8.59 8.59 0 00-2.54.32 8.5 8.5 0 002.54.33 8.5 8.5 0 002.54-.33 8.59 8.59 0 00-2.54-.32z",
    fill: "#32bedd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureSqlWarehouse);
export default __webpack_public_path__ + "static/media/azure-sqlWarehouse.a84e2d29464b0a5e08f1cdeed0db3a3b.svg";
export { ForwardRef as ReactComponent };